import * as Yup from 'yup';

export const stringArraySchema = Yup.array().test(
  'no-empty',
  'Поля не должны быть пустыми',
  (arr) => {
    if (!Array.isArray(arr)) return false;
    if (arr.length === 0) return true;

    return arr.every((item) => typeof item === 'string' && item.trim() !== '');
  }
);
